<template>
	<div class="section-buttons">
		<SectionSwitch
			:label="title"
			:value="enabled"
			:editable="editable"
			@input="onSectionToggle"
		/>
		<div class="buttons-wrapper">
			<TagButton
				v-for="(button, key) in buttonOptions"
				:key="`tag-group-button-${key}`"
				:button-id="button.id"
				:icon-name="button.icon"
				:label="transTagLabel(button.label, sportName, button.type)"
				:editable="buttonsEditable"
				:clickable="false"
				:enabled="enabled"
				@edit="$emit('btn-edit', $event)"
				@delete="$emit('btn-delete', $event)"
			/>
			<slot name="extra" />
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import TagButton from '@videotools/js/one/components/TagButton/TagButton';
import SectionSwitch from '@videotools/js/one/components/TagGroups/SectionSwitch';
export default {
	name:       'SectionButtons',
	components: { SectionSwitch, TagButton },
	props:      {
		buttons: {
			type:    Array,
			default: () => [],
		},
		title: {
			type:    String,
			default: null,
		},
		enabled: {
			type:    Boolean,
			default: true,
		},
		sectionName: {
			type:     String,
			required: true,
		},
		editable: {
			type:    Boolean,
			default: true,
		},
		buttonsEditable: {
			type:    Boolean,
			default: true,
		},
	},
	computed: {
		...mapGetters({
			sportName: 'event/sportName',
		}),
		buttonOptions() {
			return this.buttons.map(b => ({
				id:    b.id,
				label: b.name,
				type:  b.type,
				icon:  `tag-${b.name}`,
			})
			);
		},
	},
	methods: {
		onSectionToggle(enabled) {
			if (!this.editable) {
				return;
			}
			this.$emit('section-toggle', this.sectionName, enabled);
		},
	},
};
</script>

<style lang="scss" scoped>

@import '@shared/sass/shared-variables';

.section-buttons {
	padding-bottom: 16px;
}

.buttons-wrapper {
	display: grid;
	grid-template-columns: 48% 48%;
	row-gap: 16px;
	column-gap: 24px;
}

.section-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>
